import { useState, forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with an inline "eye" toggle to show/hide the value.
 * Same visual language as the other icons on the auth forms (text-white/30).
 * Preserves all Input props (data-testid, autoComplete, etc.).
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", toggleTestId, ...props },
  ref,
) {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Input
        ref={ref}
        {...props}
        type={visible ? "text" : "password"}
        className={`pr-10 ${className}`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Nascondi password" : "Mostra password"}
        aria-pressed={visible}
        data-testid={toggleTestId}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/30 hover:text-white/60 transition-colors"
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </>
  );
});

export default PasswordInput;
